export default __webpack_public_path__ + "static/media/by_receiver.0bd1a5fc.svg";